import React, { useEffect, useRef, useState } from 'react';

/**
 * Confirmation for security actions. `typeToConfirm` (e.g. "LOG OUT") makes
 * the person type the phrase first — the GitHub / Google Cloud pattern for
 * actions that hit everyone at once.
 */
export default function ConfirmDialog({ title, body, cta, tone = 'danger', typeToConfirm = '', busy = false, onConfirm, onCancel }) {
  const [typed, setTyped] = useState('');
  const firstRef = useRef(null);

  useEffect(() => {
    firstRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape' && !busy) onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [busy, onCancel]);

  const ready = !typeToConfirm || typed.trim().toUpperCase() === typeToConfirm.toUpperCase();

  return (
    <div className="ses__modal" role="dialog" aria-modal="true" aria-label={title} onClick={() => !busy && onCancel()}>
      <div className="ses__modal-box" onClick={(e) => e.stopPropagation()}>
        <h2 className="ses__modal-title">{title}</h2>
        <div className="ses__modal-body">{body}</div>
        {typeToConfirm && (
          <label className="ses__type-confirm">
            Type <b>{typeToConfirm}</b> to confirm
            <input
              ref={firstRef}
              className="ses__input"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              autoComplete="off"
              spellCheck={false}
              aria-label={`Type ${typeToConfirm} to confirm`}
            />
          </label>
        )}
        <div className="ses__modal-actions">
          <button type="button" className="ses__btn" onClick={onCancel} disabled={busy} ref={typeToConfirm ? undefined : firstRef}>Cancel</button>
          <button
            type="button"
            className={`ses__btn ${tone === 'danger' ? 'ses__btn--danger-solid' : 'ses__btn--primary'}`}
            onClick={onConfirm}
            disabled={busy || !ready}
          >
            {busy ? 'Working…' : cta}
          </button>
        </div>
      </div>
    </div>
  );
}
